// extracted by mini-css-extract-plugin
module.exports = {"inviteLink":"_3G3TbG"};